import { Component, OnInit, ViewChild } from "@angular/core";
import { NavController } from "@ionic/angular";
import { ActivatedRoute } from "@angular/router";
import { Client } from "src/app/interfaces/client";
import { RestService } from "src/app/services/rest/rest.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { StorageService } from "src/app/services/storage/storage.service";
import { User } from "src/app/interfaces/user";

@Component({
    selector: "app-pedido.page",
    templateUrl: "./pedido.page.html",
    styleUrls: ["./pedido.page.scss"],
})
export class PedidoPage implements OnInit {

    user: User;
    userRole: any;
    client: Client;    
    clienteUrl: string;

    constructor(
        private navCtrl: NavController,
        private route: ActivatedRoute,
        private rest: RestService,
        private utils: UtilsService,
        private storage: StorageService
    ) { }

    crearPedidoCliente() {
        this.navCtrl.navigateRoot("/crear-pedido?cliente=" + this.clienteUrl, {
            animated: true,
            animationDirection: "forward",
        });
    }

    crearPedidoInvitado() {
        this.navCtrl.navigateRoot("/invitado", {
            animated: true,
            animationDirection: "forward",
        });
    }

    async ngOnInit() {
        const result = await this.storage.getUser();
        if(result != undefined) this.userRole = result.role;
        if(this.userRole != 'cliente'){
            this.login()
        }
        this.route.queryParams.subscribe((params) => {
            this.clienteUrl = params.cliente;
            this.getClient(this.clienteUrl);
            console.log(this.clienteUrl); // price
        });
    }

    async getClient(clientId: string) {
        await this.utils.showLoading();
        const result: any = await this.rest.getClient(clientId);
        this.client = result.body;
        await this.utils.hideLoading();
    }

    async login() {

        const username = "invitado";
        const password = "123456";

        // TODO: Login logic
        try {

            const resp = await this.rest.login(username, password);
            localStorage.setItem("usuario", JSON.stringify(resp));
            console.log(resp);

            if (resp) {
                await this.utils.showToast("¡Bienvenido!", "success");
            } else {
                await this.utils.showToast(
                    "Username o contraseña incorrecta",
                    "danger"
                );
            }
        } catch (error) {
            await this.utils.showToast("Username o contraseña incorrecta", "danger");
        }
    }
}
